interface CollapsibleStatusProps {
  isCollapsed: boolean;
}

export function SidebarLoading({ isCollapsed }: CollapsibleStatusProps) {
  return (
    <div className="sidebar__status" role="status" aria-label="Loading menu">
      <i className="pi pi-spinner pi-spin" aria-hidden="true" />
      {!isCollapsed && <span>Loading...</span>}
    </div>
  );
}

interface SidebarErrorProps extends CollapsibleStatusProps {
  message: string;
  onRetry: () => void;
}

export function SidebarError({ message, onRetry, isCollapsed }: SidebarErrorProps) {
  return (
    <div
      className="sidebar__status sidebar__status--error"
      role="alert"
      data-pr-tooltip={isCollapsed ? message : undefined}
    >
      <i className="pi pi-exclamation-triangle" aria-hidden="true" />
      {!isCollapsed && <p>{message}</p>}
      <button
        type="button"
        className="sidebar__status-retry"
        onClick={onRetry}
        aria-label="Retry loading menu"
      >
        <i className="pi pi-refresh" aria-hidden="true" />
        {!isCollapsed && <span>Retry</span>}
      </button>
    </div>
  );
}

export function SidebarEmpty({ isCollapsed }: CollapsibleStatusProps) {
  return (
    <div className="sidebar__status" data-pr-tooltip={isCollapsed ? 'No menu items' : undefined}>
      <i className="pi pi-inbox" aria-hidden="true" />
      {!isCollapsed && <span>No menu items</span>}
    </div>
  );
}
